import { createSlice } from '@reduxjs/toolkit'
import { fetchPageContent } from '../services/fetchPageContent'
import { PageContentSchema } from '../types/PageContentSchema'

const initialState: PageContentSchema = {
    locale: 'ru',
    contact: null,
    about: null,
    features: null,
    details: null,
    price: null,
    gallery: null,
    benefits: null,
    isLoading: false,
    isInited: false
}

export const PageContentSlice = createSlice({
    name: 'pageContent',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPageContent.pending, (state) => {
                state.isLoading = true
                state.error = undefined
            })
            .addCase(fetchPageContent.fulfilled, (state, action) => {
                state.isLoading = false
                state.isInited = true
                state.locale = action.payload.locale
                state.contact = action.payload.contact
                state.about = action.payload.about
                state.features = action.payload.features
                state.details = action.payload.details
                state.price = action.payload.price
                state.gallery = action.payload.gallery
                state.benefits = action.payload.benefits
            })
            .addCase(fetchPageContent.rejected, (state, action) => {
                state.isLoading = false
                state.isInited = true
                state.error = action.payload
            })
    }
})

export const { reducer: PageContentReducer } = PageContentSlice
